@if(isLoading()) {
	<div class="overlay">
		<div class="spinner-container">
			<span class="loader"></span>
		</div>
	</div>
}